/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Error from '../../utils/error';

const withErrorReport = (componentName) => (ComponentToWrap) => {
    class ComponentWithErrorReport extends Component {
        constructor(props) {
            super(props);

            this.state = {
                error: undefined
            };

            this.handleError = this.handleError.bind(this);
        }

        componentDidCatch(error) {
            this.handleError(error);
        }

        handleError(error) {
            this.setState(
                { error },
                () => Error.send(
                    error,
                    'REACT_COMPONENT_ERROR',
                    {
                        component: componentName,
                        state: this.props.state,
                        props: this.props.props
                    }
                )
            );
        }

        render() {
            if (this.state.error) {
                return null;
            }

            return <ComponentToWrap {...this.props}/>;
        }
    }

    const mapDispatchToProps = (state = {}, props = {}) => ({
        state, props
    });

    return connect(mapDispatchToProps)(ComponentWithErrorReport);
};

export default withErrorReport;
